
import { useEffect } from 'react';
import { Message, Trip } from './types';
import { useThreadInitialization } from './hooks/useThreadInitialization';
import { useMessageHandling } from './hooks/useMessageHandling';

export const useAssistantChat = (trip: Trip | null) => {
  const {
    threadId,
    isInitializing,
    connectionError,
    handleRetry
  } = useThreadInitialization(trip);

  const {
    messages,
    isLoading,
    sendMessage,
    setInitialMessage
  } = useMessageHandling(threadId, trip);

  // Set the initial welcome message when the thread is created
  useEffect(() => {
    if (threadId && trip && messages.length === 0) {
      setInitialMessage(trip.destination);
    }
  }, [threadId, trip]);

  return {
    messages,
    isLoading,
    isInitializing,
    connectionError,
    threadId,
    handleRetry,
    sendMessage
  };
};
